var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtlasGymFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.293 1.293A1 1 0 014 2v8a1 1 0 11-2 0V7H0V5h2V2a1 1 0 01.293-.707zM5 5h14v2H5V5zM16.18 13.258A1.99 1.99 0 0014.323 12H9.677a1.99 1.99 0 00-1.857 1.258l-1.749 4.371A1 1 0 006 18v5h2v-4h8v4h2v-5a1 1 0 00-.071-.371l-1.749-4.371zM22 5h2v2h-2v3a1 1 0 01-2 0V2a1 1 0 012 0v3z"
  })));
}
export default SvgAtlasGymFill;